// require('dotenv').config()
const appConfig = {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:1337/api',
    apiPrefix: '/api',
    authenticatedEntryPath: `/dashboard`,
    unAuthenticatedEntryPath: '/sign-in/unknownPartner',
    tourPath: '/app/account/kyc-form'
}

export default appConfig